const convertNumberToMoney = (value) => {
  const decimalCount = 2
  const decimal = ','
  const thousands = '.'

  if (value === 0) return '0,00'
  if (!value) return ''

  const negativeSign = value < 0 ? '-' : ''
  let amount
  const i = parseInt(
    (amount = Math.abs(Number(value) || 0).toFixed(decimalCount)),
    10
  ).toString()
  const j = i.length > 3 ? i.length % 3 : 0

  return (
    negativeSign +
    (j ? i.substr(0, j) + thousands : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
    (decimal +
      Math.abs(amount - i)
        .toFixed(decimalCount)
        .slice(2))
  )
}

const convertMoneyToNumber = (money) => {
  let moneyStr = money.replace(/\D{2}\s/g, '')
  moneyStr = moneyStr.replace('.', '')
  moneyStr = moneyStr.replace(',', '.')
  return parseFloat(moneyStr)
}

export { convertNumberToMoney, convertMoneyToNumber }
